"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableCell = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _TableCell = require("./TableCell.js");
var _layoutTheme = require("../../styles/layout-theme.js");
var _excluded = ["align", "highlight", "truncate", "numerical", "condensed"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * Cells are the most basic unit of a table. They are contained within rows and influenced by other cells in the same column.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-table-tablecell--docs) |
 * [Encore site](https://encore.spotify.net/web/components/table) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TableCell) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-10376&t=s9ZDoQC7G8x5OYjx-1)
 */
var TableCell = exports.TableCell = /*#__PURE__*/(0, _react.forwardRef)(function TableCell(_ref, ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'start' : _ref$align,
    highlight = _ref.highlight,
    truncate = _ref.truncate,
    numerical = _ref.numerical,
    condensed = _ref.condensed,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_TableCell.TableCellElement, Object.assign({
    ref: ref,
    $align: align,
    $highlight: highlight,
    $truncate: truncate,
    $numerical: numerical,
    $condensed: condensed
  }, props, {
    className: (0, _classnames["default"])((0, _layoutTheme.textClass)(highlight ? 'bodySmallBold' : 'bodySmall'), props.className),
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.TableCell
  }));
});